module.exports = __webpack_public_path__ + "fonts/GologDernangSadris-Yigchen.ttf";